import React, { FC } from 'react';
import styles from './footer-copyright.module.scss';
import SocialIcons from '../../../../social-icons/social-icons';

interface FooterCopyrightProps {}

const FooterCopyright: FC<FooterCopyrightProps> = () => {
  return (
    <div className="footer-bottom">
      <div className="auto-container">
        <div className="outer-box">
          <div className="copyright-text">
            © {new Date().getFullYear()} Superio by{" "}
            <a
              href="https://themeforest.net/user/ib-themes"
              target="_blank"
              rel="noopener noreferrer"
            >
              ib-themes
            </a>
            . All Right Reserved.
          </div>
          <div className="social-links">
            <SocialIcons />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterCopyright;
